module.exports = "<svg width=\"12\" height=\"20\" viewBox=\"0 0 12 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0.693001 18.395L2.11 19.806L12 9.876L2.108 -1.17961e-07L0.695 1.415L9.174 9.879L0.693001 18.395Z\" fill=\"#262626\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/slider-right-arrow.svg
// module id = 456
// module chunks = 0